import { FC } from "react";

import { LayoutSkeleton } from "./LayoutSkeleton";

export const PageLoading: FC = () => {
  return (
    <div className="fixed inset-0 z-50 h-screen w-full bg-background">
      <LayoutSkeleton />
    </div>
  );
};
